module.exports = __webpack_public_path__ + "img/grid-view-inactive.e5e9ffe9.svg";